import React from 'react';
import './testbutton.scss'; // Import the CSS file for styles

const TestButton = ({ 
    variant = 'primary',
    type = 'button', // Default to 'button' type
    disabled = false,
    children,
    onClick,
    startIcon,
    endIcon,
    style,
    className,
    value,
 }) => {
  // Define styles for icons
  const iconStyles = {
    display: 'inline-flex',
  };

  return (
    <button
      className={`${variant} ${className || ''}`}
      style={{
        ...style,
      }}
      disabled={disabled}
      onClick={onClick}
      type={type} // Default to 'button' type
    >
      {/* Render startIcon if provided */}
      {startIcon && <span style={iconStyles}>{startIcon}</span>}
      {/* Render button content */}
      {children}
      {value}
      {/* Render endIcon if provided */}
      {endIcon && <span style={iconStyles}>{endIcon}</span>}
    </button>
  );
};

export default TestButton;